import React from 'react';
import Routes from './Routes';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import DebugPanel from './components/ui/DebugPanel';
import NotificationMonitor from './components/NotificationMonitor';
import { GlobalAriaAnnouncer } from './components/ui/AriaLiveRegion';

function App() {
  return (
    <AuthProvider>
      <GlobalAriaAnnouncer />
      <Routes />
      <NotificationMonitor />
      <DebugPanel />
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: 'var(--color-card)',
            color: 'var(--color-foreground)',
            border: '1px solid var(--color-border)',
          },
          success: {
            iconTheme: {
              primary: 'var(--color-success)',
              secondary: 'white',
            },
          },
          error: {
            iconTheme: {
              primary: 'var(--color-error)',
              secondary: 'white',
            },
          },
        }}
      />
    </AuthProvider>
  );
}

export default App;
